// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__LXrfs","Header":"styles_Header__I49-A","CartInfoContainer":"styles_CartInfoContainer__af8Le","dangerContainer":"styles_dangerContainer__zI4I-"};